import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

const mutateAddOwnershipChangePacket = async ({
  data,
}: {
  data: FieldValues;
}) => {
  return await axiosAuth.post(OWNERSHIP_CHANGE_PACKET, data);
};

const useAddOwnershipChangePacketMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOwnershipChangePacket,
    ...queryParams,
  });

export default useAddOwnershipChangePacketMutation;
